import { Controller } from '@hotwired/stimulus'
import consumer from '~/channels/consumer'

export default class extends Controller {
  static values = {
    userId: String
  }

  connect() {
    if (!this.userIdValue) return

    this.subscription = consumer.subscriptions.create(
      { channel: 'UserNotificationsChannel' },
      {
        received: (data) => this.handleNotification(data)
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleNotification(data) {
    if (data.type === 'compound_import_complete') {
      this.showToast(data)
    }
  }

  showToast(data) {
    const toast = document.createElement('div')
    const bgColor = data.status === 'success' ? 'bg-green-600' : 'bg-amber-600'

    toast.className = `fixed bottom-4 right-4 ${bgColor} text-white px-6 py-4 border-2 border-neutral-900 shadow-lg z-50 max-w-sm`
    toast.innerHTML = `
      <div class="flex items-start gap-3">
        <div class="flex-1">
          <p class="font-semibold text-sm uppercase tracking-wider">${this.escapeHtml(data.title)}</p>
          <p class="text-sm mt-1">${this.escapeHtml(data.message)}</p>
        </div>
        <button class="text-white/80 hover:text-white" onclick="this.closest('div').remove()">
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    `

    document.body.appendChild(toast)

    // Auto-dismiss after 8 seconds
    setTimeout(() => {
      if (toast.parentNode) {
        toast.remove()
      }
    }, 8000)
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
